import { apiDelete, apiGet, apiPost, apiPut } from './client.js';
import type {
  CreateMetricRequest,
  MetricEntry,
  MetricsRange,
  UpdateMetricRequest,
} from './metricsTypes.js';

function rangeQuery({ from, to }: MetricsRange = {}): string {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const qs = params.toString();
  return qs.length > 0 ? `?${qs}` : '';
}

export function listMetrics(range: MetricsRange = {}): Promise<MetricEntry[]> {
  return apiGet<MetricEntry[]>(`/api/metrics${rangeQuery(range)}`);
}

export function createMetric(body: CreateMetricRequest): Promise<MetricEntry> {
  return apiPost<MetricEntry>('/api/metrics', body);
}

export function updateMetric(
  id: number,
  body: UpdateMetricRequest,
): Promise<MetricEntry> {
  return apiPut<MetricEntry>(`/api/metrics/${id}`, body);
}

export function deleteMetric(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/metrics/${id}`);
}
